import { GenIcon } from '../helpers/IconBase.es.js';

const LoyaltyOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 21 18", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M4.5 8L1 8C1 12.9706 5.25329 17 10.5 17C15.7467 17 20 12.9706 20 8L16.5 8",
          stroke: "white",
          strokeWidth: "1.5"
        }
      },
      {
        tag: "circle",
        attr: {
          cx: "10.5",
          cy: "6.5",
          r: "5.75",
          stroke: "white",
          strokeWidth: "1.5"
        }
      }
    ]
  })(props);
};

export { LoyaltyOutlined };
